<template>
  <div class="cnvResult">
    <div class="public-title">RNA检测结果
      <span
        v-if="moduleAnnotation != ''"
        class="ts-info iconfont icon-zhu"
        style="color: #a4a9bf; margin-left: 20px"
        @click="isNotes()"
      ></span>
    </div>
    <div class="show-box"></div>
    <div class="main">
      <div class="t-header">
        <span>检测项目</span>
        <span>检测结果</span>
      </div>
      <div class="t-body">
        <p>IDH1基因R132突变</p>
        <p>
          <span>未突变</span>
        </p>
      </div>
      <div class="t-body">
        <p>IDH1基因R132突变</p>
        <p><span>突变</span></p>
      </div>
      <div class="t-body">
        <p>IDH1基因R132突变</p>
        <p>
          <span>未突变</span>
        </p>
      </div>
      <div class="t-body">
        <p>IDH1基因R132突变</p>
        <p><span>突变</span></p>
      </div>
    </div>
    <!-- <div class="btn">
      <div class="ts-info" @click="isNotes">
        <span>!</span>
        注释
      </div>
    </div> -->
    <Notes ref="child" :notesText="notesText" />
  </div>
</template>
<script>
import Notes from "@/components/notes.vue";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
      default:"甲基化检测结果"
    },
    moduleIsShow: {
      type: String,
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  components: {
    Notes,
  },
  data() {
    return {
      notesText: {
        h1: this.title,
        p: this.moduleAnnotation,
      },
    };
  },
  methods: {
    isNotes() {
      
      // this.$refs.child.ishow();
      if (this.$route.query.userAgent == "wxWeb") {
        this.$refs.child.ishow();
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "notes",
          notesText: this.notesText,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "notes",
            notesText: this.notesText,
            type: "",
          })
        );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.public-title {
  height: 70px;
  line-height: 70px;
  font-size: 18PX;
  font-weight: 500;
  color: #2f354d;
  padding-left: 24px;
}
.cnvResult {
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  padding-bottom: 30px;
  .btn {
    padding-left: 24px;
    .ts-info {
      width: 80px;
      height: 32px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(52, 68, 132, 0.08);
      border-radius: 16px;
      text-align: center;
      line-height: 32px;
      span {
        display: inline-block;
        width: 14px;
        min-width: 14px;
        height: 14px;
        border-radius: 14px;
        background: #ffdb4d;
        text-align: center;
        line-height: 14px;
        font-weight: 500;
        font-size: 10px;
      }

      p {
        font-size: 12px;
        font-family: @family;
        font-weight: 400;
        color: #9095a7;
        line-height: 17px;
      }
    }
  }
  .main {
    padding: 0 24px 16px;

    div {
      display: flex;
      justify-content: space-between;
    }
    .t-header {
      span {
        font-size: 15PX;
        font-weight: 500;
        color: #9095a7;
        line-height: 22px;
      }
    }
    .t-body {
      height: 48px;
      line-height: 48px;
      // &:last-child {
      //   border-bottom: 1px solid #e3e5e8;
      //   padding-bottom: 16px;
      // }
      p {
        font-size: 15PX;
        font-weight: 500;
        color: #4b84ff;
        &:last-child {
          width: 60px;
        }
      }
      span {
        font-size: 13px;
        font-weight: 400;
        padding: 2px 9px;
        background: #ebeff7;
        color: #5f697d;
      }
    }
  }
}
</style>
